import React ,{Component} from 'react';
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios';

import Button from '@mui/material/Button';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TablePagination from '@mui/material/TablePagination';
import TableBody from '@mui/material/TableBody'; 
import SettingsIcon from '@mui/icons-material/Settings';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Checkbox from '@mui/material/Checkbox'; 
import FormControlLabel from '@mui/material/FormControlLabel'; 
import IosShareOutlinedIcon from '@mui/icons-material/IosShareOutlined';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import PrintIcon from '@mui/icons-material/Print';
import EmailIcon from '@mui/icons-material/Email';
import SummarizeIcon from '@mui/icons-material/Summarize';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { blueGrey } from '@mui/material/colors';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
import EmailTwoToneIcon  from '@mui/icons-material/EmailTwoTone';
import IosShareIcon from '@mui/icons-material/IosShare';
import LocalPrintshopTwoToneIcon from '@mui/icons-material/LocalPrintshopTwoTone';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ReactToPrint from 'react-to-print';
import EditIcon from '@mui/icons-material/Edit';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
 import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 

  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});



function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}


function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}



export default class Customerviewmore extends Component {
	
    constructor(props) {
    super(props);
	
	
	var strdob = new Date();
var month = "";

if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}

const currentDate = new Date();

var month1 = (currentDate.getMonth() + 1 < 10) ? "0" + (currentDate.getMonth() + 1) : (currentDate.getMonth() + 1);
var lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
var lastDay = (lastDayOfMonth.getDate() < 10) ? "0" + lastDayOfMonth.getDate() : lastDayOfMonth.getDate();

	
 this.state = {  
 sestatus:'0',isselectdisplay:false,  checkedvalues: '' ,checkboxData:'',quotenumber:'',open:false,
	
	
	 todate1: currentDate.getFullYear() + '-' + month1 + '-' + lastDay, todate: lastDayOfMonth,setcreditterms:"",
fromdate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),iscreditlimit:false,
 fromdate1:currentDate.getFullYear() + '-' + month1 + '-' + '01',company:'',se_quotenumber:'',
redirect:false,pagename:'',CustomerData:[] ,id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
search:'',order:'desc' ,orderBy:'sin_id',
	 estimateData:[],allchecked:false,Saleinvdata:[],isselected:0,isChecked: false,sinidies:'',totalsales:'',salescurrentyr:'',outstandingamt:'',overdueamt:'',saleamtthisyear:'',totalsaleamt:'',cu_creditlimit:'',bname:'',
	credittermstype:'',cu_noofdays:'',creditermsimmediatepolicy:'',mobileno:'',phone:'',billaddress1:'',billaddress2:'',billcity:'',billpin:'',billstate:'',isactive:'',tab:"0", value:0,newValue:'',avaragesales:'',oustandingcount:'',overduecount:0,isVisible:0,
	 btndisabled:false,submitbtn:"Save",name:'',cu_id:0,note:'',cuid:'',conid:'',billstate:'',
	prevpage:0,totaldata:0,outstanding:'',overdue:'',creditlimit:'',creditterms:'',sales:'',salesyear:'',lastsale:'',avgsale:'',
	bankaccountname:'',bankroutingno:'',bankaccountno:'',iscreditterms:false,creditlimitdisable:true,noofdays:'0',cu_co_id:0,pricedefault:'',total:0,outstandingamts:0,type:'0',
   countrydata:[],countrylabel:'Select Country',statelabel:'Select State',statedata:[],coname:'',iscustbillVisible:0,iscustcontbillVisible:0,iscustemailbillVisible:0,iscustemailbillVisible:0,ispaymenttermsVisible:0,ispaymentbankVisible:0,ispaymentoptionVisible:0,
	 masterdata: [],taxdata:[],ledgerdata:[],countrylabel:'Select Country',statelabel:'Select State',isChecked: false, txtvalue:0,allchecked:false,isallchecked:false, Checkboxvalue:0,shipchecked:true,atype:'',pricedefault:'',crole:'', iconslist:true,
		ColumnData:[],exportaData:[],
	}
	      
	}
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,invoiceData:[]
    });
	

}
 myChangeHandler = (event) => {
	
  let nam = event.target.name;
  let val = event.target.value;
  
 
  
  this.setState({[nam]: val});
  

 } 


componentWillMount() {
	
	let search = window.location.href;
let Cuid = this.getParameterByName('cuid', search);
	document.title = "Isifol - Sales Invoice";

if(localStorage.getItem("ISIuserid")==null)
		 {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
		  
		 
		 if(Cuid!=null)
		 {
		this.CustomerViewmore(Cuid);	
		 }
		  
		
}
 getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

Customerdetails(cuid) {

    axios.get(localStorage.getItem("ISIurl") + 'ajaxcustomer.php?action=customersummarydata&cu_id='+cuid+'&cmp_id='+localStorage.getItem("ISIcmpid"))
        .then(resp => {
            if (resp.data.length > 0) {
             
                this.setState({
                  
                   invoiceId:resp.data[0].sin_id,
					 invoicedate:resp.data[0].invoicedate,
					 totalsales:resp.data[0].totalsales,
					 salescurrentyr:resp.data[0].salescurrentyr,
					 outstandingamt:resp.data[0].outstandingamt,
					 overdueamt:resp.data[0].overdueamt,
                    totalsaleamt:resp.data[0].totalsaleamt,
					saleamtthisyear:resp.data[0].saleamtthisyear,
					avaragesales:resp.data[0].avaragesales,	
		oustandingcount:resp.data[0].oustandingcount,	
		overduecount:resp.data[0].overduecount,				
	
                });			
		  
	this.apicall(this.state.page,this.state.rowsPerPage); 
				 // this.Productgetall(this.state.invoiceId); 
            } else {
                this.setState({ });
            }
			
			
        });
}
apicall(page,rowsPerPage){
	
	//axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=getall&sin_cu_id='+Cuid+'&sin_status='+this.state.sestatus+'&sin_quotenumber='+this.state.quotenumber+'&StartIndex='+page+'&PageSize='+rowsPerPage)
	axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=customecreditinvoicegetall&sin_cu_id='+this.state.cuid+'&sin_status='+this.state.sestatus+'&fromdate='+this.state.fromdate1+'&todate='+this.state.todate1+'&sin_quotenumber='+this.state.quotenumber+'&type='+this.state.type+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
  .then(resp => {  	
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  estimateData: resp.data,
				
			   totaldata:parseInt(resp.data[0].count),
			   rowsPaging:[],rowsPaging:copy	
			});

     }
	 
	  else{
		   this.setState({estimateData:[],totaldata:0,Saleinvdata:[]});
	 }
	 
  
    });
}











GetexportaData(id){
	
	
	axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=customecreditinvoicegetall&sin_cu_id='+this.state.cuid+'&sin_id='+id)
     
  .then(resp => {  	
    if(resp.data.length>0){
		
			this.setState({  
			  exportaData: resp.data,
			
			});

     }
	 
	  else{
		   this.setState({exportaData:[]});
	 }
	 
	
	 
  
    });
}



CustomerViewmore(Cuid) {
  axios
    .get(
      localStorage.getItem("ISIurl") +
        "ajaxcustomer.php?action=getall&cu_id=" +
        Cuid
    )
    .then(resp => {
      if (resp.data.length > 0) {
        const row = resp.data[0];

        const cu_setcreditterms = Number(row.cu_setcreditterms);
        const cu_noofdays = Number(row.cu_noofdays);
        const cu_credittermsnextmonth = Number(row.cu_credittermsnextmonth);
        const cu_creditlimit = Number(row.cu_creditlimit);

        const immediatePolicy =
          row.cu_creditermsimmediatepolicy &&
          row.cu_creditermsimmediatepolicy.trim() !== "";

        let iscreditterms = false;
        let creditTermsDisplay = "";
        let credittermstype = "0";                     
        let creditermsimmediatepolicy = "";            

        if (immediatePolicy) {
          iscreditterms = true;
          credittermstype = "3";                       
          creditTermsDisplay = "Immediately";
          creditermsimmediatepolicy =
            row.cu_creditermsimmediatepolicy;          
        }
        else if (cu_setcreditterms === 1 && cu_noofdays > 0) {
          iscreditterms = true;
          credittermstype = "1";
          creditTermsDisplay = cu_noofdays + " Days";
        }
        else if (cu_setcreditterms === 1 && cu_credittermsnextmonth === 1) {
          iscreditterms = true;
          credittermstype = "2";
          creditTermsDisplay = "End of next month";
        }

        const iscreditlimit = cu_creditlimit > 0;
        const creditlimitdisable = !iscreditlimit;

        this.setState(
          {
            CustomerData: resp.data,

            cuid: row.cu_id,
            bname: row.cu_businessname,
            name: row.cu_contactname,
            refno: row.cu_referenceno,
            emailid: row.cu_emailid,
            mobileno: row.cu_mobileno,
            phone: row.cu_phoneno,
            conid: row.cu_co_id,
            cu_shipco_id: row.cu_shipco_id,

            billaddress1: row.cu_billingaddress1,
            billaddress2: row.cu_billingaddress2,
            billcity: row.cu_billingcity,
            billstate: row.cu_billingstate,
            billpin: row.cu_billingpincode,
            tax: row.cu_tax_id,

            shipaddress1: row.cu_shippingaddress1,
            shipaddress2: row.cu_shippingaddress2,
            shipcity: row.cu_shippingcity,
            shipstate: row.cu_shippingstate,
            shippin: row.cu_shippingpincode,

            iscreditterms: iscreditterms,
            creditTermsDisplay: creditTermsDisplay,
            credittermstype: credittermstype,            
            creditermsimmediatepolicy: creditermsimmediatepolicy,

            creditlimit: cu_creditlimit,
            iscreditlimit: iscreditlimit,
            creditlimitdisable: creditlimitdisable,

            bankaccountname: row.cu_bankaccountname,
            bankroutingno: row.cu_bankroutingno,
            bankaccountno: row.cu_bankaccountno,
            pricedefault: row.cu_pricedefault,
            note: row.cu_note,
            ledger: row.cu_ledger_id,

            isactive: row.cu_isactive,
            coname: row.co_name,
            atype: row.cu_type,
            crole: row.cu_role
          },
          () => {
            this.Customerdetails(Cuid);
          }
        );

        let strname = row.cu_businessname + " (Customer)";
        this.props.parentdasCallback(
          strname + "~" + row.cu_referenceno
        );
      } else {
        this.setState({ invoiceData: [] });
      }
    });
}

handleClickSearch=()=>{	
 this.apicall(this.state.page,this.state.rowsPerPage); 
}
 countrybind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall')
	
    
      .then((resp) => {     
	  let CountryApi = resp.data.map(row => {
                      
          return {value:row.co_id, display:row.co_name}
        });
		
		  this.setState({
          countrydata: CountryApi
        });
		

      }).then(data => {
		 
        
      
		
       
      })


   
	  
}



statebind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxlocation.php?action=getall')
	
    
      .then((resp) => {     
	  let StateApi = resp.data.map(row => {
                      
          return {value:row.lo_state, display:row.lo_state}
        });
		
		 this.setState({
          statedata: [{value:'', display:'Select State'}].concat(StateApi)
        });
		this.countrybind();

      }).then(data => {
		 
        
      
		
       
      })


   
	  
}
	handlecreditterms = (event) => 
{
	this.setState({iscreditterms: !this.state.iscreditterms});
};
handleChangePage = (event, newPage) => {  

    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
   
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  };
 
  
    handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};
  
fromdatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

    
    this.setState({
        fromdate: dayjs(dateObj),
        fromdate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
}

  
  
  toatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

  }
		
	handleOpen = () => {
    this.setState({ open: true });
  };
handleClickOpen = (e) => { 
  this.setState({open:!this.state.open,
	  });
	  
		
};

  /*handleAllProducts=()=>{
	 var studArray = this.state.estimateData;
	 const updatedArray = [...this.state.estimateData];
	  this.setState({allchecked: !this.state.allchecked}, () => {
		  
		  if(this.state.allchecked===false)
		  {
			   var subnewRow = studArray.map((rowssub, j) => {
				   updatedArray[j].isseleceted = "0" ;
			   });
		  }
		  else if(this.state.allchecked===true)
		  {
			   var subnewRow = studArray.map((rowssub, j) => {
				   updatedArray[j].isseleceted = "1" ;
			   });
		  }
		  
		   this.setState({estimateData:updatedArray,});
	  });
  }*/
  
  handleAllProducts=()=>{
	  
	
	 var studArray = this.state.estimateData;
	 
	 const updatedArray = [...this.state.estimateData];
	 
	 this.setState({allchecked:!this.state.allchecked},() => {
	     if(this.state.allchecked===false)
		 {
		 var subnewRow=studArray.map((rowssub,j) => {
					 updatedArray[j].isseleceted = "0" ;
				 });
				 
		  }
		 else if(this.state.allchecked===true)
			 
			 {
				  var subnewRow = studArray.map((rowssub, j) => {
				   updatedArray[j].isseleceted = "1" ;
			   });
				 
			 }
			 
			this.setState({estimateData:updatedArray,},()=>{
				   
			
		  
		  const selectedIds = this.state.estimateData.map(item => item.sin_id);
		  const selectedIdsString = selectedIds.join(',');
		  this.setState({sinidies:selectedIdsString},()=>{
			
			 
		  });
		  
  

			});
		 
	 });
	 
	 
  }
  /*chcekbox */
  
   addcheckbox(){
    let search = window.location.href;
   
    setTimeout(() => this.refs.CheckboxAdd.handleClickOpen(),500);

 }
    
  handleInvoice =(id,rowsd)=>{

	  const updatedArray=[...this.state.estimateData];
	  if(updatedArray[rowsd].isseleceted==="0")
	  {
		  updatedArray[rowsd].isseleceted = "1" ;
		    console.log('check',updatedArray);
		  
	  }
	
	 
	  else
	  {
	  updatedArray[rowsd].isseleceted = "0" ;
	   console.log('unchcek',updatedArray);
      }
	  
	  this.setState({estimateData: updatedArray,},()=>{
		  
		 const selectedItems= this.state.estimateData.filter(item => item.isseleceted==="1")
		  const selectedIds = selectedItems.map(item => item.sin_id);
		  const selectedIdsString = selectedIds.join(',');
		  
		  this.setState({sinidies:selectedIdsString},()=>{
			  
			
			    this.GetexportaData(this.state.sinidies)
			  
		  });
		  
		 
		 if (selectedItems.length >= 2) {
         this.setState({ disablecopyicon: false });
         } 
		  
		 
	  }) ;
		  
		  
	  
  }
    OnSelectSendEmail(){
	  
	    var formData = new FormData(); 
					 formData.append('action','sendemail')	
					  formData.append('sin_id',this.state.sinidies)
					  formData.append('sin_cmp_id',localStorage.getItem("ISIcmpid"))
					  
					  
					    axios.post(localStorage.getItem("ISIurl")+"ajaxsalesinvoice.php", formData, {
						})
	  
	  
  }
  
  
  
  
  
  
  
  
     printcall = (e) => {
	
document.getElementById('print-button').click();	
}

 onClickBulkdelete(){
	
	const idsArray = this.state.sinidies.split(",").filter(id=>id.trim() !==""); 
	
    const count = idsArray.length; 
    if (count === 0) {
   this.setState({errormessage:"You Have Not Checked any checkbox Please select any one",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		 
    return; 
  }
	  
	  
	  let r = window.confirm("Do you really want to Delete?");
		 if(r == true){
			  var formData = new FormData(); 
					 formData.append('action','delete')	
					 formData.append('sin_id',this.state.sinidies)
			         formData.append('userid',localStorage.getItem("ISIuserid"))
					  axios.post(localStorage.getItem("ISIurl")+"ajaxsalesinvoice.php", formData, {
						}).then(res =>{							
							
							  this.apicall(this.state.page,this.state.rowsPerPage); 
						});
			 
		 }
	  
	  
	  
  }
   handleChange = (event, newValue) => {
    this.setState({ tab: newValue });
	
	 this.setState({                   
     Checkbox: event.target.value      
   })
  } 
pricebind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxgroupmaster.php?action=getall&gm_type=1&gm_cmp_id='+localStorage.getItem("ISIcmpid"))
	
    
      .then((resp) => {     
	  let PriceApi = resp.data.map(row => {
                      
          return {value:row.gm_id, display:row.gm_name}
        });
		
		 this.setState({
          masterdata: [{value:'', display:'Select'}].concat(PriceApi)
        });
		

      }).then(data => {
		 
        
      
		
       
      })


   
	  
}
 ledgerbind(){

 axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=getall&le_cmp_id='+localStorage.getItem("ISIcmpid"))
	 .then((resp) => {     
	  let LedgerApi = resp.data.map(row => {
                      
          return {value:row.le_id, display:row.le_code+" - "+row.le_ledgername}
        });
		 this.setState({
          ledgerdata: [{value:'', display:'Select'}].concat(LedgerApi)
        });
		
		this.pricebind();
      }).then(data => {
		 
        
      
		
       
      })


   
	  
}
  taxbind(){

    axios.get(localStorage.getItem("ISIurl")+'ajaxtax.php?action=getall&tx_cmp_id='+localStorage.getItem("ISIcmpid")+'&tx_mainid=0')
	 .then((resp) => {     
	  let TaxApi = resp.data.map(row => {
                      
          return {value:row.tx_id, display:row.tx_name}
        });
		 this.setState({
          taxdata: [{value:'', display:'Select'}].concat(TaxApi)
        });
		this.ledgerbind();
      }).then(data => {
		 
        
      
		
       
      })


   
	  
}  
 customerupdate(val){
	 this.setState({cu_id:val,iscustbillVisible:1});
	 this.statebind();
     }
	customercontact(val){
        this.setState({cu_id:val,iscustcontbillVisible:1});     

      }
	  customercontactemail(val){
        this.setState({cu_id:val,iscustemailbillVisible:1});     

      }
	  customeremail(val){
        this.setState({cu_id:val,iscustemailbillVisible:1});     

      }
	   paymentupdate(val){
        this.setState({cu_id:val,ispaymenttermsVisible:1});     

      }
	    paymentbankupdate(val){
        this.setState({cu_id:val,ispaymentbankVisible:1});     

      }
  noteupdate(val){	 
        this.setState({cu_id:val,isVisible:4}); 
		}
		optionsupdate(val){	 
        this.setState({cu_id:val,ispaymentoptionVisible:1}); 
		this.taxbind();
		}
  handleCancel = () => {
    this.setState({
      isVisible:0,iscustbillVisible:0,iscustcontbillVisible:0,iscustemailbillVisible:0,ispaymenttermsVisible:0,ispaymentbankVisible:0,ispaymentoptionVisible:0
    });
  }
  	handlecreditlimitChange = (event) => 
{
	
	this.setState({iscreditlimit: !this.state.iscreditlimit,creditlimitdisable:!this.state.creditlimitdisable},()=>{});
};
  handleradiocredit = (event) => 
{
	this.setState({credittermstype: event.target.value});
};	
	
handlenoteClose = (e) => {
	
	
	let bname=this.state.bname;
    let name = this.state.name;
    let conid = this.state.conid;
	let billaddress1 = this.state.billaddress1;
	let billaddress2= this .state.billaddress2;
    let billcity = this.state.billcity;
    let billstate = this.state.billstate;
    let billpin=this.state.billpin;
	let shipaddress1 = this.state.shipaddress1;
	let shipaddress2= this .state.shipaddress2;
    let shipcity = this.state.shipcity;
    let shipstate = this.state.shipstate;
    let shippin=this.state.shippin;
	let emailid=this.state.emailid;
	let phone=this.state.phone;
	let mobileno=this.state.mobileno;
      let note = this.state.note;
let tax = this.state.tax;
let creditlimit=this.state.creditlimit;
let iscreditterms=this.state.iscreditterms,striscreditterms="0",strcredittermstype="0";
let credittermstype=this.state.credittermstype;
let creditermsimmediatepolicy=this.state.creditermsimmediatepolicy;
let noofdays=this.state.noofdays;
let ledger =this.state.ledger;
let bankaccountno=this.state.bankaccountno;
let bankaccountname=this.state.bankaccountname;
let pricedefault=this.state.pricedefault;
let atype=this.state.atype;
let Cuid=this.state.cuid;
let crole=this.state.crole;
 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  if(iscreditterms===true)
	{
		striscreditterms="1";
	}
if(credittermstype==="2")
	{
		strcredittermstype="1";
	}
	if(credittermstype!=="1")
	{
		noofdays="0"
		
	}else{
		noofdays=this.state.cu_noofdays;
	}
  
   if(this.state.cu_id===0)
	  {
		  formData.append('cu_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('cu_id',this.state.cu_id)
		
          }
	 
        formData.append('action','update') 
		formData.append('cu_businessname',bname)
		formData.append('cu_contactname',name)
		formData.append('cu_co_id',conid) 
		formData.append('cu_billingaddress1',billaddress1)
		formData.append('cu_billingaddress2',billaddress2) 
		formData.append('cu_billingcity',billcity)
		formData.append('cu_billingstate',billstate) 
		formData.append('cu_billingpincode',billpin)
		formData.append('cu_tax_id',tax)		
		formData.append('cu_emailid',emailid)
		formData.append('cu_phoneno',phone) 
		formData.append('cu_mobileno',mobileno) 
		formData.append('cu_shippingaddress1',shipaddress1)
		formData.append('cu_shippingaddress2',shipaddress2) 
		formData.append('cu_shippingcity',shipcity)
		formData.append('cu_shippingstate',shipstate) 
		formData.append('cu_shippingpincode',shippin)
		formData.append('cu_creditlimit',creditlimit)
		formData.append('cu_setcreditterms',striscreditterms)
	
			formData.append('cu_credittermsnextmonth',strcredittermstype) 
		formData.append('cu_noofdays',noofdays)
		formData.append('cu_creditermsimmediatepolicy',this.state.creditermsimmediatepolicy)
		formData.append('cu_bankaccountname',bankaccountname)
		formData.append('cu_pricedefault',pricedefault)
		formData.append('cu_note',note)
		formData.append('userid',localStorage.getItem("ISIuserid"))
		formData.append('cu_ledger_id',ledger)
		formData.append('cu_type',atype)
		formData.append('cu_role',crole)
		formData.append('cu_cmp_id',localStorage.getItem("ISIcmpid"))
		

		axios.post(localStorage.getItem("ISIurl")+"ajaxcustomer.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Name Already Exist.",erropen:true,open:true,isVisible:0,iscustbillVisible:0,iscustcontbillVisible:0,iscustemailbillVisible:0,ispaymenttermsVisible:0,ispaymentbankVisible:0,ispaymentoptionVisible:0
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}else{
			this.setState({isVisible:0,iscustbillVisible:0,iscustcontbillVisible:0,iscustemailbillVisible:0,ispaymenttermsVisible:0,ispaymentbankVisible:0,ispaymentoptionVisible:0
	
		});
		this.CustomerViewmore(this.state.cu_id);
	}
	
	
         
    
        });
 
	
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });
	 
};	
clearTextField = (e) => {
    this.setState({ 
	
		  iscreditterms:'',
	  credittermstype:'',
	  noofdays:'',
	 creditermsimmediatepolicy:'',
	 bankaccountname:'',
	 bankroutingno:'',
	  bankaccountno:'', cu_id: 0,refno:'',pricedefault:'',ledger:'',tax:'', });
  }	
  
  
  
  
  
  
       addprintbox(){
    setTimeout(() => this.refs.PrintBox.handleClickOpen(),500);

    }
	  
  
  
  
  
	render()
	{
		
		const { checkedvalues } = this.state;
		return(
		   <React.Fragment>
		
	<div className="customviewmore">	
	<ul>
	<li>
	<div className="customerinvoiceleft">
	<h4>Outstanding({this.state.oustandingcount}) </h4>
	<p>${this.state.outstandingamt}</p><br/>
	<h4>Credit Limit</h4>
	<p>${this.state.creditlimit}</p>
	</div>
	<div className="customerinvoicerght">
	<h4>Overdue ({this.state.overduecount})</h4>
	<p className="overdueamt">${this.state.overdueamt}</p><br/>
	<h4>Credit Terms</h4>
<p>
  {this.state.iscreditterms
    ? this.state.creditTermsDisplay
    : "-"}
</p>
	</div>
	<div className="clear"></div>	 
	</li>
	<li>
	<div className="customerinvoiceleft">
	<h4>Sales to date({this.state.totalsales})</h4>
	<p>${this.state.totalsaleamt}</p><br/>	
	<h4>Last Sale</h4>
	<p>{this.state. invoicedate}</p>
	</div>
	<div className="customerinvoicerght">
	<h4>Sales this year ({this.state.totalsales})</h4>
	<p>${this.state.saleamtthisyear}</p><br/>
	<h4>Average Sale</h4>
	<p>${this.state.avaragesales}</p>
	</div>
	<div className="clear"></div>	
	</li>
	
	<li>
	<div className="customerinvoicelefts">
	<h4>{this.state.bname}</h4>
	<p><span><PhoneIcon/></span> &nbsp; &nbsp; {this.state.mobileno};{this.state.phone}<div className="clear"></div></p>
	<p><span><EmailIcon/></span>&nbsp; &nbsp; {this.state.emailid} <div className="clear"></div></p>
	<p><span><LocationOnIcon/></span>&nbsp; &nbsp; {this.state.billaddress1},{this.state.billaddress2},{this.state.billcity},{this.state.billstate},{this.state.billpin}<div className="clear"></div></p>

	</div>
	<div className="customerinvoicerghts">
	<h4>Account Status</h4>
	<p>{this.state.isactive}</p>	
	</div>
	<div className="clear"></div>	 
	
	
		</li>
	</ul>
	</div>
<Box sx={{ width: '100%', typography: 'body1' }}>
  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
    <Tabs
      initialSelectedIndex={0}
      value={this.state.tab || "0"}
      onChange={this.handleChange}
      aria-label="lab API tabs example"
    >
      <Tab label="Activity" value="0" />
      <Tab label="Contacts & Addresses" value="1" />
      <Tab label="Payment Details" value="2" />
      <Tab label="Options" value="3" />
      <Tab label="Notes" value="4" />
    </Tabs>
  </Box>

    </Box>	
<div className="tabbox">
 {this.state.tab==="0" && (<React.Fragment>	 
	<div className="searchbox">
<ul>

	



 <li>
        <p>Search</p>
        <p>
          <TextField
            variant="outlined"
            fullWidth
			className="txtbox"
            value={this.state.quotenumber}
            id="quotenumber"
            inputProps={{ tabIndex: "1", maxLength: 150 }}
            name="quotenumber"
            onChange={this.myChangeHandler}
            InputProps={{
              endAdornment: (
                <SearchOutlinedIcon style={{ marginLeft: 8 }} />
              ),
            }}
          />
        </p>
      </li>
		  
		  
<li>

<p><p>From Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.fromdate) }
className="txtbox"
    onChange={this.fromdatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
</LocalizationProvider></p>

</li>


<li>


<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate) }
className="txtbox"
onChange={this.toatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>
	
	
	
	
<li>
<p>Status</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="role"
  value={this.state.sestatus}
  name="sestatus"
  inputProps={{tabIndex: "4"}}
        ><option value={0}>All</option>
	<option value={2}>Outstanding</option>
		
  </Select></p>


</li>
<li>
<p>Type</p> <p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="type"
  value={this.state.type}
  name="type"
  inputProps={{tabIndex: "4"}}
        ><option value={0}>All</option>
	<option value={1}>Sales Invice</option>
	<option value={2}>Sales Credit Note</option>
		
  </Select></p>


</li>	

	
<li>
<p>&nbsp;</p>
	 <p className="searchbutton">
       <Button
  type="submit"
  variant="contained"
  className="frmSecondarybtn"
  onClick={this.handleClickSearch}
>
 
  Search 
</Button>      
      </p>
		
				
		</li>
		
			
		
</ul>







{this.state.iconslist===true && (
		
<div className="iconlistprint">
<p>

<Tooltip title="Print" placement="top">
  <IconButton>
  <LocalPrintshopIcon onClick={()=>{this.refs.PrintBox.handleClickPrint()}}/>
  </IconButton>
</Tooltip>


<Tooltip title="Email" placement="top">
  <IconButton>
   <EmailTwoToneIcon  onClick={()=>{this.OnSelectSendEmail()}}/>
  </IconButton>
</Tooltip>
&nbsp; &nbsp;
  <Tooltip title="Export" placement="top">
 
  <ReactHTMLTableToExcel
    id="exportbtndisble"
    table="Estimate"
    filename="Customer View MOre Report"
    sheet="Customer View MOre Report"
    buttonText= <IosShareIcon />
    style={{display:"none" }} 
  /> 
  
   <IconButton onClick={() => { this.GetexportaData(); }}>
  </IconButton>
</Tooltip>

 

  



 </p>

</div>	

	)}


</div>	
	




 <PrintBox ref="PrintBox" childcols={this.state.ColumnData} cuid={this.state.cuid} sinidies={this.state.sinidies}/>



	
<div className="estimatebox">
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container}>  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
       <TableCell>
<Checkbox 
 checked={this.state.allchecked}
  onChange={()=>{this.handleAllProducts()}}
  inputProps={{ 'aria-label': 'controlled' }}
/>
 </TableCell>
		  
		    <TableCell>Invoice Date</TableCell>	
            <TableCell>Number </TableCell>			
		    <TableCell>Reference </TableCell>	
		<TableCell>Type </TableCell>					
			<TableCell>Total </TableCell>		
			<TableCell>Discount </TableCell>				
            <TableCell>Oustanding </TableCell>
			
			
			
			  
          </TableRow>
        </TableHead>

 

  <TableBody>

{stableSort(this.state.estimateData, getSorting(this.state.orderBy, this.state.order)).map((item,index) => {  

let strlink="",strtype="";

if(item.type==="1")
{strtype="Sales Invoice";
	strlink="#/Salesinvoiceviewmore?sinoid=";
}else if(item.type==="2")
{
	strtype="Sales Credit Notes";
	strlink="#/Salecreditnoteviewmore?scnoid=";
}
           return ( <React.Fragment>
 <TableRow key={index} >


 <TableCell>
 {item.isseleceted==="0" && (
<Checkbox
  
  onChange={()=>{this.handleInvoice(item.sin_id,index)}}
  inputProps={{ 'aria-label': 'controlled' }}
/> 
)}{item.isseleceted==="1" && (
<Checkbox
  checked
  onChange={()=>{this.handleInvoice(item.sin_id,index)}}
  inputProps={{ 'aria-label': 'controlled' }}
/> 
)}


</TableCell>

<TableCell><a className="link" href={strlink+item.sin_id+""}>{item.invoicedate}</a></TableCell>
<TableCell><a className="link" href={strlink+item.sin_id+""}>{item. sin_invoiceno}</a></TableCell>
 <TableCell><a className="link" href={strlink+item.sin_id+""}>{item.sin_reference}</a></TableCell>
  <TableCell><a className="link" href={strlink+item.sin_id+""}>{strtype}</a></TableCell>
 <TableCell><a className="link" href={strlink+item.sin_id+""}>{item.iop_total}</a></TableCell>
 <TableCell><a className="link" href={strlink+item.sin_id+""}>{item.sin_discount}</a></TableCell>
 
<TableCell><a className="link" href={strlink+item.sin_id+""}>{item.iop_total - item.outstandingamt}</a></TableCell>
 
 
 
 </TableRow>


				</React.Fragment>	
				);
					})}
					
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
					
					
 </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20,50, 100, 150,200]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onRowsPerPageChange={this.handleChangeRowsPerPage}  
      />    
  </Paper>
   
 </div>
 </React.Fragment>
	)}





<div style={{ "display": "none" }}>
  <Paper className={useStyles.root}>
    <TableContainer className={useStyles.container}>
      <Table stickyHeader aria-label="sticky table" id="Estimate">
        <TableHead>
          <TableRow>
            <TableCell>Invoice Date</TableCell>
            <TableCell>Number </TableCell>
            <TableCell>Reference </TableCell>
            <TableCell>Type </TableCell>
            <TableCell>Total </TableCell>
            <TableCell>Discount </TableCell>
            <TableCell>Outstanding </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {this.state.exportaData.map((item, index) => {
			  
			   
let strtype="" ,strlink="";

if(item.type==="1")
{strtype="Sales Invoice";
	strlink="#/Salesinvoiceviewmore?sinoid=";
}else if(item.type==="2")
{
	strtype="Sales Credit Notes";
	strlink="#/Salecreditnoteviewmore?scnoid=";
}	


			  
			  
            return (
              <React.Fragment>
                <TableRow key={index}>
                  <TableCell>{item.invoicedate}</TableCell>
                  <TableCell>{item.sin_invoiceno}</TableCell>
                  <TableCell>{item.sin_reference}</TableCell>
                  <TableCell>{strtype}</TableCell>
                  <TableCell>{item.iop_total}</TableCell>
                  <TableCell>{item.sin_discount}</TableCell>
                  <TableCell>{item.iop_total - item.outstandingamt}</TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}

          {this.state.totaldata === 0 && (
            <TableRow key={0}>
              <TableCell align="center" colSpan={this.state.colcount}>
                No Records
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </Paper>
</div>















 {this.state.tab==="1" && (	 


 <React.Fragment>
{this.state.CustomerData.map((item,index) => { 

 return ( <React.Fragment>
	  <div className="contacts">
	  {this.state.iscustbillVisible == "0" && ( 	
  <ul>

<div className="addreslefts">
<li><h4>{item.cu_contactname}</h4> </li>
<li><p>{item.atype}</p></li>
<li>{item.cu_billingaddress1}</li>
<li>{item.cu_billingcity}</li>
<li>{item.cu_billingstate}</li>
<li>{item.cu_billingpincode}</li>
<li>{item.co_name}</li>
</div>
<div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.customerupdate(item.cu_id)}}><EditIcon /></span>
</div> 
</ul>
	  )}
{this.state.iscustbillVisible == "1" && ( 

 <React.Fragment>

<div className="contactform1">
<div className="addreslefts">

<ul>
<li>
<p className="popformtext">Address Type</p> <p className="popforminputs"><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="atype"
  value={this.state.atype}
  name="atype"
  inputProps={{tabIndex: "4"}} 
        ><option Default value={3}>Sales</option>
		<option value={1}>Delivery</option>
	<option value={2}>Acounts</option>
	
	<option value={4}>Purchasing</option>	
  </Select></p>
<div className="clear"></div>

</li>	
<li>	
						  
	<p className="popformtext">  Business Name</p>
		
	
	<p className="popforminputs"><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.name}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>				
<li>

		 <p className="popformtext"> Country</p>
	
		  	
		  <p  className="popforminputs"><FormControl  className="stadrp">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.countrylabel, value: this.state.conid}}
          onChange={this.myChangeHandler}
          id="conid"
		   value={this.state.conid} className="txtbox"
		  name="conid"
		inputProps={{tabIndex: "2"}}
		
        >
		{this.state.countrydata.map(con => (
            <option  
            
              value={con.value}
            >
              {con.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
		</p>
		<div className="clear"></div>
		  </li>
	<li>	
	
			  
	<p className="popformtext">  Address 1</p>
	

	<p className="popforminputs"><TextField name="billaddress1" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    
	   value={this.state.billaddress1}
		 inputProps={{tabIndex: "3"}}	 
			  ref={this.usernameInput}
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>

					  
	<li>	
						  
	<p className="popformtext">Address 2</p>


	<p className="popforminputs"><TextField name="billaddress2" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.billaddress2}
			 inputProps={{tabIndex: "4"}}	 
			 
			  className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>

	
<li>	
						  
	<p className="popformtext">Town/City</p>
	
	
	<p className="popforminputs"><TextField name="billcity" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.billcity}
			 
			 
			  inputProps={{tabIndex: "5",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>

<li>

		 <p className="popformtext"> State <span className="validation">*</span></p>
		
		  	
		  <p><FormControl   className="popforminputs">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.statelabel, value: this.state.billstate}}
          onChange={this.myChangeHandler}
          id="billstate"
		   value={this.state.billstate}
inputProps={{tabIndex: "11",maxLength:150}}		  
		  name="billstate"
		   className="txtbox"
		inputProps={{tabIndex: "6"}}
		
        >
		{this.state.statedata.map(states => (
            <option  
            
              value={states.value}
            >
              {states.display}
            </option  >
          ))}
		
        </Select></FormControl>
		 <div className="clear"></div>
		</p>
		
		  </li>
<li>	
			  
	<p className="popformtext"> Zip Code</p>

	
	<p className="popforminputs"><TextField name="billpin" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.billpin}
			 inputProps={{tabIndex: "7",maxLength:15}}
			 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
              
		  /></p>
		 
		  <div className="clear"></div>
</li>					  
	</ul></div>
</div>
<div className="clear"></div>

       <div className="actionbtns">
	  
	  <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleCancel}>
Cancel
</Button>
</div> 


<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handlenoteClose}>
    {this.state.submitbtn}
</Button>
    </div> 	
<div className="clear"></div>
</div>
</React.Fragment>
)}
</div> 
  <div className="contacts">
   {this.state.iscustcontbillVisible == "0" && (
  <ul>
<div className="addreslefts customerinvoicelefts">
<li><h4><b>{item.cu_businessname}</b></h4></li>
<li><p>{item.cu_role}</p></li>
<li><p><span><EmailIcon/></span>&nbsp; &nbsp;{item.cu_emailid}<div className="clear"></div></p></li>
<li><p><span><PhoneAndroidIcon/></span> &nbsp; &nbsp;{item.cu_phoneno}<div className="clear"></div></p></li>
<li><p><span><PhoneIcon/></span> &nbsp; &nbsp;{item.cu_mobileno}<div className="clear"></div></p></li>
</div>
<div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.customercontact(item.cu_id)}}><EditIcon /></span>
</div>


</ul>
   )}
 {this.state.iscustcontbillVisible == "1" && (
 <React.Fragment>  
   <div className="contactform1">
<div className="addresright">
<ul>
<li>	
						  
	<p className="popformtext"> Name</p>
		
	
	<p className="popforminputs"><TextField name="bname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bname}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "8",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>				
 <li>	
	
			  
	<p className="popformtext">Role</p>
	

	<p className="popforminputs"><TextField name="crole" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    
	   value={this.state.crole}
		 inputProps={{tabIndex: "9",maxLength:150}}	 
			 
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>
 
 

	<li>	
	
			  
	<p className="popformtext">Email</p>
	

	<p className="popforminputs"><TextField name="emailid" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    
	   value={this.state.emailid}
		 inputProps={{tabIndex: "10",maxLength:150}}	 
			 
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>

					  
	<li>	
						  
	<p className="popformtext">Telephone</p>


	<p className="popforminputs"><TextField name="phone" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.phone}
			 inputProps={{tabIndex: "11",maxLength:100}}	 
			 
			  className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>


<li>	
						  
	<p className="popformtext">Mobile</p>


	<p className="popforminputs"><TextField name="mobileno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.mobileno}
			 inputProps={{tabIndex: "12",maxLength:100 }}	 
			 
			  className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>
	
	<p className="popformtext"> <FormControlLabel
        label="copy email to this person"
        control={ <Checkbox   inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
	
  
	</ul></div>
</div>
<div className="clear"></div>

       <div className="actionbtns">
	  
	  <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleCancel}>
Cancel
</Button>
</div> 


<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handlenoteClose}>
    {this.state.submitbtn}
</Button>
    </div>        


	

</div>
<div className="clear"></div>
   </React.Fragment>
)}
</div>

  <div className="contacts">
   {this.state.iscustemailbillVisible == "0" && (
<ul >
<div className="addreslefts">
<li><h4><b>{item.cu_contactname}</b></h4></li>
<li>{item.cu_emailid}</li>

</div>
<div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.customercontactemail(item.cu_id)}}><EditIcon /></span>
</div>

</ul>
   )}
    {this.state.iscustemailbillVisible == "1" && (
 <React.Fragment>  
 <div className="contactform1">
<div className="addresright">
<ul>
<li>	
						  
	<p className="popformtext"> Name</p>
		
	
	<p className="popforminputs"><TextField name="bname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bname}
			 
			 
			  inputProps={{tabIndex: "8",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>				
 
 <li>	
	
			  
	<p className="popformtext">Role</p>
	

	<p className="popforminputs"><TextField name="crole" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    
	   value={this.state.crole}
		 inputProps={{tabIndex: "9",maxLength:150}}	 
			 
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>
 

	<li>	
	
			  
	<p className="popformtext">Email</p>
	

	<p className="popforminputs"><TextField name="emailid" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    
	   value={this.state.emailid}
		 inputProps={{tabIndex: "10",maxLength:150}}	 
			 
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>

					  
	<li>	
						  
	<p className="popformtext">Telephone</p>


	<p className="popforminputs"><TextField name="phone" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.phone}
			 inputProps={{tabIndex: "11",maxLength:100}}	 
			 
			  className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>


<li>	
						  
	<p className="popformtext">Mobile</p>


	<p className="popforminputs"><TextField name="mobileno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   
	   value={this.state.mobileno}
			 inputProps={{tabIndex: "12",maxLength:100 }}	 
			 
			  className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>
	
	<p> <FormControlLabel
        label="copy email to this person"
        control={ <Checkbox   inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
	
  
	</ul></div>
</div>
<div className="clear"></div>

       <div className="actionbtns">
	  
	  <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleCancel}>
Cancel
</Button>
</div> 


<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handlenoteClose}>
    {this.state.submitbtn}
</Button>
    </div>        


	

</div>
<div className="clear"></div>
  </React.Fragment> 
	)}
 
</div>





 </React.Fragment>
 )
  })
  }
  
 
 </React.Fragment>
)}

 {this.state.tab==="2" && (	
 <React.Fragment>

{this.state.CustomerData.map((item,index) => { 

 return ( <React.Fragment>
	
<div className="viewcontacts">
{this.state.ispaymenttermsVisible == "0" && (

  <ul className="payments">
  <h5>Payment Terms</h5>
  <div className="addreslefts">

<li><p className="popformtext"><span><b>Credit Limit</b></span></p><p className="popforminputs">{item.cu_creditlimit}</p><div className="clear"></div></li>
<li>
  <p className="popformcheckbx">
    <span><b>Credit Terms</b></span>
  </p>
  <p className="popformcheckbxinput">
    {this.state.iscreditterms
      ? this.state.creditTermsDisplay
      : "-"}
  </p>
</li>

{this.state.iscreditterms &&
 this.state.credittermstype === "3" && (
<li>
  <p className="popformtext">
    <span><b>Terms and Conditions</b></span>
  </p>
  <p className="popforminputs">
    {this.state.creditermsimmediatepolicy}
  </p>
</li>
)}

</div>
<div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.paymentupdate(item.cu_id)}}><EditIcon /></span>
</div>

</ul>
)}
{this.state.ispaymenttermsVisible == "1" && (
<React.Fragment>
<div className="Accountform">
    <div className="addreslefts">
<ul>

 <h2>Payment Terms</h2>
	<li>	
						  
	<p className="popformtext"> <FormControlLabel
        label="Set Credit Limits($)"
        control={ <Checkbox  checked={this.state.iscreditlimit}  onChange={this.handlecreditlimitChange}  name="iscreditlimit"
			id="iscreditlimit" inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>
	
		
	<p className="popforminputs"><TextField name="creditlimit" 
	   onChange={this.myChangeHandler}  
	   fullWidth
	 disabled={this.state.creditlimitdisable}
			  value={this.state.creditlimit}
			  inputProps={{tabIndex: "21"}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						 
		  <div className="clear"></div>
</li>	

				  
	<li>	
					  
	<p className="popformcheckbx"><FormControlLabel
        label="Set Credit Terms"
        control={ <Checkbox  checked={this.state.iscreditterms}  onChange={this.handlecreditterms}  inputProps={{ 'aria-label': 'controlled' }} />}
      /></p>

<p className="popformcheckbxinput"></p>  <div className="clear"></div>
</li>



 {this.state.iscreditterms===true && (<React.Fragment>

<li>

<p className="popformcheckbx">
 <FormControl>
   
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="1"
        name="radio-buttons-group"
		
		  value={this.state.credittermstype}
    onChange={this.handleradiocredit}
      >
        <FormControlLabel value="1" control={<Radio />} label="days after invoice date" />
        <FormControlLabel value="2" control={<Radio />} label="End of next month (Net monthly)" />
        <FormControlLabel value="3" control={<Radio />} label="Immediately" />
      </RadioGroup>
    </FormControl>

</p><p className="popformcheckbxinput">
	 {this.state.credittermstype==="1" && (<React.Fragment>
	<TextField name="cu_noofdays" 
	   onChange={this.myChangeHandler} 
	   
	   fullWidth
	   
	    value={this.state.cu_noofdays}
	 
	  inputProps={{tabIndex: "22"}}
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
                         />
						
	</React.Fragment> )};</p>  <div className="clear"></div>
			
			</li></React.Fragment>)}
			 {this.state.credittermstype==="3" && (<React.Fragment>
<li>			
<p><TextField name="creditermsimmediatepolicy" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
	     rows={3}
	   value={this.state.creditermsimmediatepolicy}
	     inputProps={{tabIndex: "23"}}
			 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
              
		  /></p>
						 
	
</li>

	</React.Fragment>)}		  


</ul></div>
	<div className="clear"></div>
</div>

  <div className="actionbtns">
	  
	  <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleCancel}>
Cancel
</Button>
</div> 


<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handlenoteClose}>
    {this.state.submitbtn}
</Button>
    </div>
	<div className="clear"></div>
</div>

</React.Fragment>
)}
</div>
<div className="viewcontacts">
{this.state.ispaymentbankVisible == "0" && (

  <ul className="payments">
  <h5>Bank Details</h5>
 <div className="addreslefts">
<li><p className="popformtext"><span><b>Account Name</b></span></p><p className="popforminputs">{item.cu_bankaccountname}</p><div className="clear"></div></li>
<li><p className="popformtext"><span><b>ABA/Routing Number</b> </span></p><p className="popforminputs"><a onClick={()=>{this.paymentbankupdate(item.cu_id)}}> Add an ABA/Routing Number</a></p><div className="clear"></div></li>
<li><p className="popformtext"><span><b>Account Number</b></span></p><p className="popforminputs"> <a onClick={()=>{this.paymentbankupdate(item.cu_id)}}>Add an Account Number</a></p><div className="clear"></div></li>
</div>
<div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.paymentbankupdate(item.cu_id)}}><EditIcon /></span>
</div>

</ul>
)}
{this.state.ispaymentbankVisible == "1" && (
 <React.Fragment>
 <div className="contactform1">
<div className="addresright">
<ul>
<h5>Bank Details</h5>
<li>	
						  
	<p className="popformtext"> Account Name</p>
		
	
	<p className="popforminputs"><TextField name="bankaccountname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bankaccountname}
			 
			 
			  inputProps={{tabIndex: "8",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>				
 
 	<li>	
	
			  
	<p className="popformtext">ABA/Routing Number</p>
	

	<p className="popforminputs"><TextField name="bankroutingno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    
	   value={this.state.bankroutingno}
		 inputProps={{tabIndex: "9",maxLength:150}}	 
			 
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>
 

	<li>	
	
			  
	<p className="popformtext">Account Number</p>
	

	<p className="popforminputs"><TextField name="bankaccountno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	    
	   value={this.state.bankaccountno}
		 inputProps={{tabIndex: "9",maxLength:150}}	 
			 
			   className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
		  <div className="clear"></div>
</li>  
	</ul>
	</div>
	<div className="clear"></div>
</div>


       <div className="actionbtns">
	  
	  <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleCancel}>
Cancel
</Button>
</div> 


<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handlenoteClose}>
    {this.state.submitbtn}
</Button>
    </div>        

 <div className="clearbtn">
           <Button className="clearbtn" onClick={this.clearTextField}>
              Clear
            </Button>
          </div>  
<div className="clear"></div>	

</div>

  </React.Fragment>
)}

</div> 
 </React.Fragment>
 )
  })}
  
 </React.Fragment>  
 )}
 {this.state.tab==="3" && (	
 <React.Fragment>

{this.state.CustomerData.map((item,index) => { 

 return ( <React.Fragment>
	
<div className="viewcontact">
{this.state.ispaymentoptionVisible == "" && (
  <ul className="payments">
  <h5>Account Details</h5>
<div className="addresleft">

<li><p className="popformtext"><span><b>Business Name</b></span></p><p className="popforminputs">{item.cu_businessname}</p><div className="clear"></div></li>
<li><p className="popformtext"><span><b>Reference</b></span></p><p className="popforminputs"> {item.cu_referenceno}</p><div className="clear"></div></li>
<li><p className="popformtext"><span><b>Price Default</b></span></p><p className="popforminputs">{item.gm_name}</p><div className="clear"></div></li>
<li><p className="popformtext"><span><b>Account Default</b></span></p><p className="popforminputs">{item.le_code}- {item.le_displayname}</p><div className="clear"></div></li>
<li><p className="popformtext"><span><b>Tax Rate</b></span></p><p className="popforminputs"> {item.tx_name}</p><div className="clear"></div></li>

</div>
<div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.optionsupdate(item.cu_id)}}><EditIcon /></span>
</div>
</ul> 
)}
{this.state.ispaymentoptionVisible == "1" && (
 <React.Fragment>
 <div className="Accountform">
   <h5>Account Details</h5>
    <div className="addreslefts">
<ul>

<li>	
						  
	<p className="popformtext">  Business Name <span className="validation">*</span></p>
		
	
	<p className="popforminputs"><TextField name="bname" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bname}
			 
			 
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>					  


	<li>	
						  
	<p className="popformtext">Reference<span className="validation">*</span></p>
	
	
	<p className="popforminputs"><TextField name="refno" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.refno}
			 
			 
			  inputProps={{tabIndex: "3",maxLength:12}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						   
		  <div className="clear"></div>
</li>

<li>
<p className="popformtext">Price Default</p>
  <p><FormControl  className="popforminputs">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.masterlabel, value: this.state.pricedefault}}
          onChange={this.myChangeHandler}
          id="pricedefault"
		   value={this.state.pricedefault}  className="txtbox"
		  name="pricedefault"
		inputProps={{tabIndex: "27"}}
		
        >
		{this.state.masterdata.map(cons => (
            <option  
            
              value={cons.value}
            >
              {cons.display}
            </option  >
          ))}
		
        </Select></FormControl>
		 <div className="clear"></div>
		</p>	 
</li>


<li>

		 <p className="popformtext"> Account Default</p>
		
		  
		  <p ><FormControl  className="popforminputs">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.ledgerlabel, value: this.state.ledger}}
          onChange={this.myChangeHandler}
          id="ledger"
		
		   value={this.state.ledger} className="txtbox"
		  name="ledger"
		inputProps={{tabIndex: "13"}}
		
        >
		{this.state.ledgerdata.map(ledger => (
            <option  
            
              value={ledger.value}
            >
              {ledger.display}
            </option  >
          ))}
		
        </Select></FormControl>
		 <div className="clear"></div>
		</p>
		 
		  </li>

<li>

		 <p className="popformtext"> Tax Rate <span className="validation">*</span></p>
		
		  	
		  <p><FormControl className="popforminputs">
         
        <Select
         native  fullWidth		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.taxlabel, value: this.state.tax}}
          onChange={this.myChangeHandler}
          id="tax"
		   className="txtbox"
		   value={this.state.tax} 
		  name="tax"
		inputProps={{tabIndex: "14"}}
		
        >
		{this.state.taxdata.map(tax => (
            <option  
            
              value={tax.value}
            >
              {tax.display}
            </option  >
          ))}
		
        </Select></FormControl>
		 <div className="clear"></div>
		</p>
		 
		  </li>


</ul>

</div></div>
<div className="clear"></div>

       <div className="actionbtns">
	  
	  <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleCancel}>
Cancel
</Button>
</div> 


<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handlenoteClose}>
    {this.state.submitbtn}
</Button>
    </div>        

 <div className="clearbtn">
            <Button className="clearbtn" onClick={this.clearTextField}>
              Clear
            </Button>
          </div>  
	
	

</div>
<div className="clear"></div>
 </React.Fragment>
)}
</div> 
 </React.Fragment>
 )
  })}
  
 </React.Fragment> 
 )}
 {this.state.tab==="4" && (<React.Fragment>	
 <React.Fragment>

{this.state.CustomerData.map((item,index) => { 

 return ( <React.Fragment>
{this.state.isVisible == "0" && ( 
<div className="contacts">	
<ul className="payments">
<div className="addreslefts">
<li><p><span><b>Note</b></span>{item.cu_note}</p></li>
</div>
<div className="addresediticon">
<span className="addtitle"  onClick={()=>{this.noteupdate(item.cu_id)}}><EditIcon /></span>
</div>
</ul>
</div>
)}
 </React.Fragment>
 )
  })}
  
 </React.Fragment> 
{this.state.isVisible == "4" && ( 

 <React.Fragment>
	
<ul className="payments">
<li><div className="Accountform">
 <p>Notes</p>
<p><TextField name="note" 
	   onChange={this.myChangeHandler} 
	 fullWidth
	      multiline
          rows={4}
	   value={this.state.note}
		inputProps={{tabIndex: "28"}}	 
			 
			 className="txtbox"
	   InputLabelProps={{ shrink: true }}
              
		  /></p>	
 </div>	
</li>
</ul>
     <div className="actionbtns">
	  
	  <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.handleCancel}>
Cancel
</Button>
</div> 


<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handlenoteClose}>
    {this.state.submitbtn}
</Button>
    </div>        


	

</div>
<div className="clear"></div>

 </React.Fragment>
 )
  }

	
 	</React.Fragment>
	)}
	<div className="clear"></div>  </div> </React.Fragment>	
		
	
	 
	)		
		
	}
	
	
}
/*print box*/
 

  export class PrintBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      printopen: false,
	  CustomerArray:[],
    };
  }

 handleClickPrint = () => {

this.GetCustomerBYIdes(this.props.sinidies)
  
};


  
GetCustomerBYIdes(id){

axios.get(localStorage.getItem("ISIurl")+'ajaxsalesinvoice.php?action=customecreditinvoicegetall&sin_id='+id+'&sin_cu_id='+this.props.cuid)

     
  .then(resp => {  	
  
  console.log('resp.data',resp.data);
  
    if(resp.data.length>0){
		
			this.setState({  
			  CustomerArray:resp.data,  
			 	
			},()=>{
				 setTimeout(() =>
document.getElementById('print-button').click() 
,500);
				
			});

     }
	 
	  else{
		   this.setState({CustomerArray:[]});
	 }
	 
  
    });
}

  
  

  render() {
 return (
	
	 <React.Fragment>
	 <div className="printmod">
	<div ref={el => (this.componentRef = el)} >
	
	
<Paper className={useStyles.root}>
<TableContainer className={useStyles.container} >  
<Table stickyHeader aria-label="sticky table"> 
 <TableHead>
          <TableRow>
		 
          
			     <TableCell>Invoice Date</TableCell>	
            <TableCell>Number </TableCell>			
		    <TableCell>Reference </TableCell>	
		<TableCell>Type </TableCell>					
			<TableCell>Total </TableCell>		
			<TableCell>Discount </TableCell>				
            <TableCell>Oustanding </TableCell>

          </TableRow>
        </TableHead>

 

  <TableBody>

{this.state.CustomerArray.map((item,index) => {  


let strtype="" ,strlink="";

if(item.type==="1")
{strtype="Sales Invoice";
	strlink="#/Salesinvoiceviewmore?sinoid=";
}else if(item.type==="2")
{
	strtype="Sales Credit Notes";
	strlink="#/Salecreditnoteviewmore?scnoid=";
}	



           return ( 
 <TableRow key={index} >


<TableCell>{item.invoicedate}</TableCell>
<TableCell>{item. sin_invoiceno}</TableCell>
 <TableCell>{item.sin_reference}</TableCell>
  <TableCell>{strtype}</TableCell>
 <TableCell>{item.iop_total}</TableCell>
 <TableCell>{item.sin_discount}</TableCell>
 
<TableCell>{item.iop_total - item.outstandingamt}</TableCell>
	
	

 </TableRow>

	);	})}
					
			
					
					
					
 </TableBody>


</Table>
  </TableContainer> 
 
  </Paper>
   

 
</div>
<ReactToPrint 
            trigger={() => <p id="print-button" className="Primarybuttons">Print </p>}
			content={() =>  this.componentRef} />
		</div>	
			 </React.Fragment>
	
 ); 
 
 
 }
}



